import * as d3 from '../../scripts/lib/d3.js'
import renderMap from './render_map.js'
import hilight from './hilight_path.js'
import unhilight from './unhilight_path.js'

riot.tag2('munis-map', '<div class="{getClass(\'svg-wrapper\')}" id="svg-map"></div>', '', 'class="{getClass()}"', function(opts) {

  this.on('mount', () => {
    this.selection = renderMap({
      element: d3.select('#svg-map'),
      getClass: this.getClass
    })
  })

  riot.control.on(riot.EVT.hilight, id => this.hilighted = hilight(this.selection, id, this.hilighted))
  riot.control.on(riot.EVT.unhilight, () => unhilight(this.hilighted))

});



// WEBPACK FOOTER //
// ./src/components/munis-map/munis-map.tag